import { Data } from 'signup-constants/signupData/Data';
import { DataOptions } from '../signup-data/signupDataOptions';
import { BaseButtonsView } from './BaseButtonsView';
import { jsx as _jsx } from "react/jsx-runtime";
const CompanySizeView = () => {
  const options = DataOptions[Data.CompanySize];
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    options: options,
    shouldCenterLastRow: true,
    shouldDisableAutofocus: true
  });
};
export default CompanySizeView;